<template>
  <div class="container-shared">
    <shared-header
      v-if="isGanttInstanceLoaded"
      :gantt-instance="ganttInstance"
    />

    <div class="container-content">
      <gantt-view @ready="initGanttInstance" />
      <div
        class="filter-box"
      >
        <portal-target name="portal-filter-sidebar" />
      </div>
    </div>
  </div>
</template>

<script>
import globalStore from '$$globalStore';
import SharedHeader from './sharedHeader/SharedHeader.vue';
import GanttView from '../ganttView/ganttView.vue';
import ganttViewConstructor from '../ganttView/init';

export default {
  name: 'SharedGanttView',
  components: {
    SharedHeader,
    GanttView,
  },
  props: {
    projectId: {
      type: Number,
      default: null,
    },
    multiviewId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      isGanttInstanceLoaded: false,
    };
  },
  computed: {
    currentFilter() {
      return globalStore.getters['filter/currentFilter'];
    },
  },
  watch: {
    currentFilter(val) {
      this.ganttInstance.callEvent('export:onChangeFilterState');
    },
  },
  created() {
    this.ganttInstance = null;
  },
  methods: {
    initGanttInstance() {
      if (this.multiviewId) {
        this.ganttInstance = ganttViewConstructor.initGanttInstanceExportMultiview(+this.multiviewId);
      } else {
        this.ganttInstance = ganttViewConstructor.initGanttInstanceExport(+this.projectId);
      }

      this.isGanttInstanceLoaded = true;
    },
  },
};
</script>

<style scoped lang="less">
.container-shared {
  height: 100vh;
  width: 100vw;
}

.container-content {
  position: relative;
  height: calc(100vh - 90px);
  width: 100vw;
}

.filter-box {
  height: 100%;
  position: absolute;
  right: 0px;
  width: 0px;
  top: 0px;
  z-index: 99;
  .vue-portal-target {
    height: 100%;
    background: #fff;
    > div {
      height: 100%;
    }
  }
}
</style>
